import React, { Component } from "react";
import { Link } from "react-router-dom";
import HypenaNav from "../../common/HypenaNav";
import HypenaFooter from "../../common/HypenaFooter";
import errorIllustration from "../../../assets/images/shapes/error-illustration.png";

class Error extends Component {
  render() {
    const base = process.env.PUBLIC_URL || "";
    return (
      <div className="hypena-page-wrap">
        <HypenaNav />
        <div className="hn-breadcrumb">
          <h1>Page not found</h1>
          <nav className="hn-breadcrumb-nav">
            <Link to={`${base}/`}>Home</Link>
            <i className="bi bi-chevron-right" />
            <span>404</span>
          </nav>
        </div>
        <section className="hn-section" style={{ textAlign: "center", paddingTop: 48, paddingBottom: 80 }}>
          <div style={{ maxWidth: 360, margin: "0 auto 24px" }}>
            <img src={errorIllustration} alt="" style={{ width: "100%", height: "auto" }} />
          </div>
          <h2 className="hn-section-title" style={{ marginBottom: 8 }}>That page was not found</h2>
          <p style={{ color: "var(--hn-gray5)", marginBottom: 24 }}>The link may be broken or the page may have been removed.</p>
          <Link to={`${base}/`} className="hn-btn hn-btn-primary">
            Go to home
          </Link>
        </section>
        <HypenaFooter />
      </div>
    );
  }
}

export default Error;
